import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

export default class DropdownList extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(value, productAttributes) {
        const { product } = this.props;

        const productAttributeId = productAttributes.productAttributeId;
        const productAttributeMapId = value.productAttributeMappingId;
        const attributeValueId = value.id;
        const optionClicked = {
            productAttributeId,
            productAttributeMapId,
            attributeValueId
        };

        this.props.selectOption(optionClicked);
        // remove disable class from Select Plan button once a selection is made from dropdown
        $(".wireless-btn-" + product.id).removeClass("disabled-button");
        // remove button tool tip once a selection is made from dropdown
        $(".tooltip-wrapper-" + product.id).removeAttr("data-tooltip");
        // change dropdown title to current dropdown selection name and price
        $(".dropdown-title-" + product.id).text(value.name + " - " + value.priceAdjustment + " Month");
        $(".carrier-dropdown").removeClass("dropdown--active");
    }

    render() {
        const { productAttributes } = this.props;
        const values = productAttributes.values;

        if (values.length > 0) {
            return _.map(values, value =>
                <div key={value.id}>
                    <li className="dropdown-list-item" onClick={() => {
                        this.onClick(value, productAttributes);
                    }}>
                        <a>{value.name} - {value.priceAdjustment} <Translate value="misc.month" /></a>
                    </li>
                </div>
            );
        }

        return "";
    }
}